import React, { useCallback, useContext, useState } from "react";
import {
  _get_admin_time_zone_localStorage,
  _get_consultant_from_localStorage,
  _get_user_from_localStorage,
} from "../DAL/localstorage/LocalStorage";
import { baseUri, socketBaseUrl } from "src/config/config";
import io from "socket.io-client";

const CreateContentSetting = React.createContext();
const get_user = _get_user_from_localStorage();
const get_consultant = _get_consultant_from_localStorage();

export const useContentSetting = () => useContext(CreateContentSetting);

let socket = {};
socket = io(socketBaseUrl + `?user_id=${get_user._id}&role=delegate`);

export function ContentSettingState({ children }) {
  const [adminTimeZone, setAdminTimeZone] = useState(
    _get_admin_time_zone_localStorage,
  );

  const [userInfo, setUserInfo] = useState(get_user);
  const [consultantInfo, setConsultantInfo] = useState(get_consultant);
  const [userExerciseHistory, setUserExerciseHistory] = useState([]);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [userExerciseHistoryLoading, setUserExerciseHistoryLoading] =
    useState(false);
  const setUserExerciseHistoryCallback = useCallback((val) => {
    setUserExerciseHistory(val);
  }, []);
  const [selectedExercise, setSelectedExercise] = useState("");
  const [googleClientId, setGoogleClientId] = useState("");
  const [tinymceKey, setTinymceKey] = useState("");
  const [programTab, setProgramTab] = useState("");
  const [isOpenNotePad, setIsOpenNotePad] = useState(false);
  const [selectedNotepad, setSelectedNotepad] = useState({});
  const [isOpenFormsList, setIsOpenFormsList] = useState(false);
  const [selectedFormsMember, setSelectedFormsMember] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [navbarSubtitle, setNavbarSubtitle] = useState("");
  const [showNavBackButton, setShowNavBackButton] = useState(false);

  const handleAdminTimeZone = (val) => {
    setAdminTimeZone(val);
  };

  const handlesetTinyKey = (val) => {
    setTinymceKey(val);
  };

  const handleGoogleId = (val) => {
    setGoogleClientId(val);
  };

  const handleUnreadMessageCount = (val) => {
    setUnreadMessageCount(val);
  };

  const handleSetUserInfo = (val) => {
    setUserInfo(val);
  };
  const handleConsultantInfo = (val) => {
    setConsultantInfo(val);
  };

  const START_SOCKET_FORCEFULLY = (user_id) => {
    socket = io(socketBaseUrl + `?user_id=${user_id}&role=delegate`);
  };

  const STOP_SOCKET_FORCEFULLY = () => {
    socket = io(socketBaseUrl + `?user_id=${userInfo._id}&role=delegate`);
    socket.disconnect();
  };

  const collection = {
    adminTimeZone,
    setAdminTimeZone,
    handleSetUserInfo,
    userInfo,
    setUserInfo,
    consultantInfo,
    handleConsultantInfo,
    handleAdminTimeZone,
    userExerciseHistory,
    userExerciseHistoryLoading,
    setUserExerciseHistoryLoading,
    selectedExercise,
    setSelectedExercise,
    setUserExerciseHistory: setUserExerciseHistoryCallback,
    START_SOCKET_FORCEFULLY,
    STOP_SOCKET_FORCEFULLY,
    socket,
    handleUnreadMessageCount,
    unreadMessageCount,
    handleGoogleId,
    googleClientId,
    handlesetTinyKey,
    tinymceKey,
    programTab,
    setProgramTab,
    isOpenNotePad,
    setIsOpenNotePad,
    selectedNotepad,
    setSelectedNotepad,
    isOpenFormsList,
    setIsOpenFormsList,
    selectedFormsMember,
    setSelectedFormsMember,
    pageTitle,
    setPageTitle,
    navbarSubtitle,
    setNavbarSubtitle,
    showNavBackButton,
    setShowNavBackButton,
  };

  return (
    <CreateContentSetting.Provider value={collection}>
      {children}
    </CreateContentSetting.Provider>
  );
}
